// Copyright (c) 2017 Deere & Company

import {translate} from '../../shared/services/translation-service';

export const getCreditMemoDisplayText = creditMemoNumber =>
    creditMemoNumber ? creditMemoNumber : translate('DISPLAY');

export const getCreditMemoFormName = creditMemoNumber =>
    creditMemoNumber ?
        'CREDITMEMO' :
        'CLM_CREDITMEMO';

export const getCreditMemoObjectId = (creditMemoNumber, claimNumber) =>
    creditMemoNumber ?
        creditMemoNumber :
        claimNumber;



// WEBPACK FOOTER //
// ./src/shared/services/credit-memo-services.js